export function hexToRgba(hexColor, opacity) {
    var r = parseInt(hexColor.substr(1, 2), 16);
    var g = parseInt(hexColor.substr(3, 2), 16);
    var b = parseInt(hexColor.substr(5, 2), 16);
    return "rgba(".concat(r, ",").concat(g, ",").concat(b, ",").concat(opacity, ")");
}
var memory = {};
export function hexToRgbaMemoized(hexColor, opacity) {
    var key = hexColor + opacity;
    if (!memory[key])
        memory[key] = hexToRgba(hexColor, opacity);
    return memory[key];
}
